module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-wrap",
    class: {
      'component-padded': _vm.base.padded, 'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), (_vm.base.title) ? _c('div', {
    staticClass: "component-header"
  }, [_c('div', {
    staticClass: "component-title"
  }, [_c('div', [_vm._v(_vm._s(_vm.base.title))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.base.subtitle))])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    style: ({
      textAlign: _vm.config.align
    })
  }, _vm._l((_vm.content), function(item) {
    return _c('p', {
      staticClass: "paragraph"
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-more"
  }, [_c('div', {
    staticClass: "three-dot"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-153822e9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153822e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/writing.vue
// module id = 2489
// module chunks = 0